// extracted by mini-css-extract-plugin
export default {"card_profile":"RecentDevicesProfile_card_profile__Rl86n","card_title":"RecentDevicesProfile_card_title__E7U1w","card_info_text":"RecentDevicesProfile_card_info_text__cQBw+"};